export const reviveAdData = {
  addTop: {
    zoneId: '23925',
    reviveId: '727bec5e09208690b050ccfc6a45d384',
    dimension: [728, 90]
  },
  addRight: {
    zoneId: '23924',
    reviveId: '727bec5e09208690b050ccfc6a45d384',
    dimension: [300, 600]
  },
  addLeft: {
    zoneId: '23923',
    reviveId: '727bec5e09208690b050ccfc6a45d384',
    dimension: [300, 250]
  },
  mobSm: {
    zoneId: '23926',
    reviveId: '727bec5e09208690b050ccfc6a45d384',
    dimension: [320, 50]
  },
  addBottom: {
    zoneId: '23928',
    reviveId: '727bec5e09208690b050ccfc6a45d384',
    dimension: [728, 90]
  },
  add300: {
    zoneId: '24280',
    reviveId: '727bec5e09208690b050ccfc6a45d384',
    dimension: [300, 300]
  }
}
